import {
  MarqBrandEnumsWebsiteBrandSortedColumnEnum,
  MarqCommonEnumsSortedOrderEnum,
  MarqCommonEnumsSwWebsiteDelistingProgressEnum,
  MarqCommonEnumsSwWebsiteReportProgressEnum,
  MonitoringWebsiteContentWebsiteContentCommonProtocolsGetWebsiteListRequest,
} from '~/swagger/data-contracts';

export const enum WebsiteContentTabGroupEnum {
  Scanned = 'scanned',
  Flagged = 'flagged',
  InProgress = 'in-progress',
  CaseClosed = 'case-closed',
  TestPurchase = 'test-purchase',
}

export type FilterQueryParams = Omit<
  MonitoringWebsiteContentWebsiteContentCommonProtocolsGetWebsiteListRequest,
  'tab' | 'tp_sub_tab' | 'limit' | 'scanned_date'
> & {
  scanned_date_start?: string | null;
  scanned_date_end?: string | null;
  offset?: number;
};

export const enum WebsiteContentColumnEnum {
  Domain = 'domain',
  Screenshot = 'screenshot',
  IpAddress = 'ip_address',
  Title = 'title',
  Country = 'country',
  Tag = 'tag',
  Comment = 'comment',
  FirstScanned = 'first_scanned',
  MetaDescription = 'meta_description',
  Registrant = 'registrant',
  Registrar = 'registrar',
  HostingProvider = 'hosting_provider',
  MxRecords = 'mx_records',
  SslCertificate = 'ssl_certificate',
  LogoDetected = 'logo_detected',
  RegistrationDate = 'registration_date',
  ExpirationDate = 'expiration_date',
  Actions = 'actions',
  TestPurchaseId = 'test_purchase_id',
  TestPurchaseProgress = 'test_purchase_progress',
  TestPurchaseReport = 'test_purchase_report',
}

export type reportStatus = MarqCommonEnumsSwWebsiteDelistingProgressEnum | MarqCommonEnumsSwWebsiteReportProgressEnum;

// SortedColumnEnum 중에서 실제로 사용하는 것들만 추려냄
type SortColumn = Extract<
  MarqBrandEnumsWebsiteBrandSortedColumnEnum,
  'scanned_date' | 'request_date' | 'domain_name' | 'updated_date' | 'comment_date'
>;
export type SortValue = `${SortColumn}+${MarqCommonEnumsSortedOrderEnum}`;

export type ViewMode = 'table' | 'grid' | 'test-purchase';

// EditColumnDialog에서 사용할 동적 컬럼 타입 (Actions 제외)
export type DynamicWebsiteContentColumn = Exclude<WebsiteContentColumnEnum, WebsiteContentColumnEnum.Actions>;
